export default "__VITE_ASSET__DmUEJfYG__"